module.exports = __webpack_public_path__ + "static/media/pdf-icn.facfddff.svg";